import { createMemoryHistory, createRouter } from 'vue-router'
import mainHome from '../components/mainHome.vue'
import appCenter from '../components/appCenter.vue'
import Company from '../components/Company.vue'
import addWe from '../components/addWe.vue'

import appInfoE100 from '../components/appView/appInfoE100.vue'
import appInfoV100 from '../components/appView/appInfoV100.vue'
import appInfoApp from '../components/appView/appInfoApp.vue'
import appInfoC100 from '../components/appView/appInfoC100.vue'

const routes = [
  {
    path: '/',
    name:"mainHome",
    component: mainHome
  },
  {
	  path:'/appCenter',
    name:"appCenter",
	  component:appCenter
  },
  {
	  path:'/Company',
    name:"Company",
	  component:Company
  },
  {
	  path:'/addWe',
    name:"addWe",
	  component:addWe
  },
  {
	  path:'/appInfoE100',
    name:"appInfoE100",
	  component:appInfoE100
  },
  {
	  path:'/appInfoV100',
    name:"appInfoV100",
	  component:appInfoV100
  },
  {
	  path:'/appInfoApp',
    name:"appInfoApp",
	  component:appInfoApp
  },
  {
	  path:'/appInfoC100',
    name:"appInfoC100",
	  component:appInfoC100
  },
]

const router = createRouter({
  history: createMemoryHistory(),
  routes,
})

export default router